import classNames from "classnames";
import React, { useRef } from "react";
import { ClickAwayListener } from "@fidget/common/components/form/clickAwayListener";
import { TooltipComponent } from "@fidget/common/components/tooltipComponent";
import styles from "./inputWithDropdown.css";

interface BaseProps extends React.HTMLProps<HTMLInputElement> {
  hasError?: boolean;
  errorHint?: string;
  onOutsideClick(): void;
  onArrowClick(): void;
  isOpen: boolean;
  onResetInput(): void;
}
interface Props extends React.PropsWithChildren<BaseProps> {}

export const InputWithDropdown = ({
  hasError,
  errorHint,
  children,
  isOpen,
  onOutsideClick,
  onArrowClick,
  onResetInput,
  ...inputProps
}: Props) => {
  const arrowRef = useRef<HTMLElement | undefined>();
  const clearCrossRef = useRef<HTMLElement | undefined>();

  const renderErrorHint = (hint: string) => (
    <div className={styles["error-feedback"]}>
      <TooltipComponent positionPreset={"top left"} text={hint} maxWidth={"240px"} style={"error"}>
        <i className={classNames("icon-exclamation-mark")} />
      </TooltipComponent>
    </div>
  );

  const renderInput = () => (
    <div className={classNames(styles["input-wrap"])}>
      {hasError && errorHint ? (
        renderErrorHint(errorHint)
      ) : (
        <i className={classNames("icon-search", styles.icons)} />
      )}

      <input type="text" {...inputProps} />
      {!!inputProps.value && (
        <i
          className={classNames("icon-close-cross", styles.icons, styles["close-cross"])}
          onClick={onResetInput}
          ref={(el) => (clearCrossRef.current = el || undefined)}
        />
      )}
      <i
        className={classNames("icon-arrow-up", styles.icons, {
          [styles["arrow-inactive"]]: !isOpen
        })}
        onClick={onArrowClick}
        ref={(el) => (arrowRef.current = el || undefined)}
      />
    </div>
  );

  const renderDropdown = () => {
    return (
      <div className={styles.dropdown}>
        <ClickAwayListener
          onClickAway={onOutsideClick}
          insideTargetDivs={[arrowRef, clearCrossRef]}
        >
          {children}
        </ClickAwayListener>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      {renderInput()}
      {isOpen && renderDropdown()}
    </div>
  );
};
